// @flow
import React from 'react';
import './Menu.scss';

type Props = {};

class HomePage extends React.Component<Props> {
  render() {
    return (
      <div className="footer">
        <p>2018</p>
      </div>
    );
  }
}

export default HomePage;



/** WEBPACK FOOTER **
 ** ./src/components/Common/Footer.js
 **/